export default "__VITE_ASSET__BAydHF16__"